import React from "react";
import { Paper } from "@material-ui/core";

import Chart from "./components/Chart";
import moment from "moment";

const processData = (data) => {
  return data.map(item => {
    return {
      x: moment(item.date).utc(true).toDate().getTime(),
      y: item.value,
    }
  });
}

function TemperatureChart({ classes, data }) {
  data = processData(data);
  const series = [
    {
      name: "Temperature",
      data: data,
    },
  ];
  const options = {
    tooltip: {
      x: {
        show: true,
        format: 'HH:mm',
      },
    },
    title: {
      text: "Last 24h readings",
      align: "left",
    },
    xaxis: {
      type: 'datetime',
      title: {
        text: "Time",
      },
      min: new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
      max: new Date().getTime(),
    },
    yaxis: {
      title: {
        text: "Temperature",
      },
      min: 0,
      max: 60,
    },
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Chart options={options} series={series} type="line" height={350} />
    </Paper>
  );
}

export default TemperatureChart;
